import type { View, ViewTagsMap } from "../models/TrendingModelsV2";
import { getViewFromLocal } from "./LocalStorageUtils";

export const hasUnsavedViewChanges = (
	viewTags: ViewTagsMap,
	viewSelected: View | null,
): boolean => {
	if (!viewSelected) return Object.keys(viewTags).length > 0;

	const savedViewTags = getViewFromLocal(viewSelected.ViewId);
	if (!savedViewTags) return false;

	return JSON.stringify(viewTags) !== JSON.stringify(savedViewTags);
};
